export function dataInRequest(params = {}) {
  return {
    type: '@recalculaTurno/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@recalculaTurno/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@recalculaTurno/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@recalculaTurno/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@recalculaTurno/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@recalculaTurno/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@recalculaTurno/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@recalculaTurno/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@recalculaTurno/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@recalculaTurno/RECORD_FILTERING',
    payload: { params },
  };
}
